<template>
  <nav class="navbar is-primary is-fixed-top">
    <div class="navbar-brand">
      <button
        class="app-menu-toggler button is-primary is-inverted"
        :class="{
          'is-outlined': !$store.state.appMenuOpen
        }"
        @click="$store.dispatch('toggleAppMenu')"
      >
        <span class="mdi mdi-format-list-bulleted-square"></span>
      </button>
      <a class="navbar-item" :href="localePath('index')">
        <img src="~/assets/images/logo.png" alt="logo" />
      </a>
      <div
        class="navbar-burger burger"
        data-target="navMenuColorprimary-example"
        @click="$store.dispatch('toggleAppNavbar')"
        :class="{ 'is-active': $store.state.appNavbarOpen }"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div
      id="navMenuColorprimary-example"
      class="navbar-menu"
      :class="{ 'is-active': $store.state.appNavbarOpen }"
    >
      <div class="navbar-end">
        <nuxt-link
          v-for="locale in this.$i18n.locales"
          :key="locale.code"
          :to="switchLocalePath(locale.code)"
          class="navbar-item"
          :class="{'is-active': $i18n.locale == locale.code}"
          exact
        >{{ locale.name }}</nuxt-link>
        <div class="navbar-item">
          <div class="field is-grouped">
            <p class="control">
              <button class="button is-primary is-inverted" @click="$auth.logout()">
                <span class="icon">
                  <i class="mdi mdi-logout-variant"></i>
                </span>
                <span>{{ $t("message.logout") }}</span>
              </button>
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <span class="navbar-link is-hidden-touch" ref="langs">{{ activeLocale }}</span>
          <div class="navbar-dropdown" @click="$event.target.blur()">
            <nuxt-link
              v-for="locale in this.$i18n.locales"
              :key="locale.code"
              :to="switchLocalePath(locale.code)"
              class="navbar-item"
              :class="{ 'is-active': $i18n.locale == locale.code }"
              exact
            >{{ locale.name }}</nuxt-link>
          </div>
        </div>
        <div class="navbar-item">
          <div class="field is-grouped">
            <p class="control">
              <button class="button is-primary is-inverted" @click="$auth.logout()">
                <span class="icon">
                  <i class="mdi mdi-logout-variant"></i>
                </span>
                <span>{{ $t("message.logout") }}</span>
              </button>
            </p>
          </div>
        </div>
      </div>-->
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      showNavbar: false
    };
  },

  computed: {
    activeLocale() {
      return this.$i18n.locales.find(e => e.code === this.$i18n.locale).name;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/nuxt/components/App/Header.vue